export default function IndexSection() {
  const items = [
    { label: '动作大片', icon: 'ri-fire-line', color: 'bg-primary-100 text-primary-600' },
    { label: '科幻巨制', icon: 'ri-rocket-line', color: 'bg-accent-100 text-accent-700' },
    { label: '悬疑推理', icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-700' },
    { label: '喜剧合家欢', icon: 'ri-emotion-laugh-line', color: 'bg-primary-100 text-primary-600' },
    { label: '古装传奇', icon: 'ri-ancient-gate-line', color: 'bg-accent-100 text-accent-700' },
    { label: '都市情感', icon: 'ri-heart-line', color: 'bg-secondary-100 text-secondary-700' },
    { label: '综艺娱乐', icon: 'ri-tv-line', color: 'bg-primary-100 text-primary-600' },
    { label: '动画动漫', icon: 'ri-ghost-line', color: 'bg-accent-100 text-accent-700' },
    { label: '纪录片', icon: 'ri-earth-line', color: 'bg-secondary-100 text-secondary-700' },
  ];

  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
              内容导航
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              主题索引
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              按内容类型快速定位，找到你感兴趣的视频品类
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {items.map((item) => (
              <a
                key={item.label}
                href="#carousel"
                className="group flex items-center gap-3 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-background-200/70 transition-all duration-300 cursor-pointer no-underline"
              >
                <div className={`flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-xl ${item.color} group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.label}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}